module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/246-india-c3aab4cb03c3070536930fadbbdccffc.svg";